export { default as ProductQuestions } from './product-questions'; 